import React, { useEffect, useState } from 'react'
import ProjectCard from './components/ProjectCard'
import FormCard from './components/FormCard'
import { useQuery } from 'react-query'
import getProjects from '../../api/getProjects'
import { useDispatch } from 'react-redux';
import { updateTitle } from '../../redux/updatePageHeadeSlice';
import { HOME_PAGE_HEADER } from '../../constants/headerTitles';
import { useHistory } from 'react-router-dom'
import getRecentActivity from '../../api/getRecentActivity';
import NewProjectModel from './newProjectModel';
import newProject from '../../api/newProject';

export default function Homepage() {
    const [recentActivity, setRecentActivity] = useState([])
    const [showModel, setShowModel] = useState(false)
    const [data, setData] = useState({ project_name: "", description: "" });
    const dispatch = useDispatch()
    const nevigate = useHistory()
    const { isLoading, data: apiData } = useQuery("project data", () => getProjects());
    const { isLoading: recentLoading, data: recentActivityData } = useQuery("getRecentActivity", () => getRecentActivity());

    useEffect(() => {
        dispatch(updateTitle(HOME_PAGE_HEADER))
    }, [])

    useEffect(() => {
        if (recentActivityData?.data) {
            const activity = [];
            recentActivityData?.data.map(item => {
                item.map(subObj => activity.push(subObj))
            })
            setRecentActivity(activity)
        }
    }, [recentActivityData?.data])

    const toggleModel = () => {
        setData({ project_name: "", description: "" })
        setShowModel(!showModel)
    }

    const submitNewProject = async () => {
        await newProject(data);
        toggleModel()
    }

    return (
        <>
            <NewProjectModel
                show={showModel}
                handleClose={toggleModel}
                handleSave={submitNewProject}
                data={data}
                setData={setData}
            />
            <div className="recent-activities">
                <h3>ACTIVITÉS RÉCENTES</h3>
                <div className='flex flex-wrap activity'>
                    {recentActivity?.map(activityObj => (
                        <FormCard
                            project_name={activityObj?.form_associated_project}
                            formName={activityObj?.form_name}
                            lastUpdated={activityObj?.form_last_modification_date}
                            description={activityObj?.description}
                        />
                    ))}
                </div>
            </div>

            {/* project list */}
            <div className="recent-activities projects-list">
                <div className="d-flex justify-content-between project-list-head">
                    <h3>PROJETS</h3>
                    <div className="project-list-right">
                        <input type="search" placeholder="search projects" className="searchbox" />
                        <button className="add-btn" onClick={toggleModel}><i className="ti-plus mr-2"></i>  Nouveau Projet</button>
                    </div>
                </div>
                <div className="flex flex-wrap gap-7" style={{ maxWidth: '90%' }}>
                    {apiData?.data.map(({ project_name, description, _id, created_by, project_icon }, i) => {
                        let index = i;
                        if (index > 9) {
                            const tmp = index.toString().slice(index.toString().length - 1)
                            index = Number(tmp)
                        }
                        {/* const tempIndex = apiData?.data.length - index - 1 */ }
                        {/* console.log('tempIndex', tempIndex) */ }
                        return (
                            <ProjectCard
                                id={_id}
                                description={description}
                                projectName={project_name}
                                icon={project_icon}
                                created_by={created_by}
                            />
                        )
                    })}
                </div>
            </div>
        </>
    )
}
